<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row align-items-center mb-3">
                <div class="datatable-header">
                  <div class="row align-items-center mb-3">
                    <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                      <router-link
                        class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                        :to="{ name: 'AddUserRole' }"
                        >+ Dodaj ulogu</router-link
                      >
                    </div>
                    <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                      <div
                        class="d-flex align-items-lg-center flex-column flex-lg-row"
                      ></div>
                    </div>
                    <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                      <div
                        class="d-flex align-items-lg-center flex-column flex-lg-row"
                      >
                        <label class="ws-nowrap me-3 mb-0">Show:</label>
                        <select
                          class="form-control select-style-1 results-per-page"
                          name="results-per-page"
                          v-model="searchConfig.pageSize"
                          @change="changePageSize(searchConfig.pageSize)"
                        >
                          <option
                            :value="page"
                            v-for="page in pageSizeList"
                            :key="page"
                          >
                            {{ page }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-lg-auto ps-lg-1">
                      <div
                        class="search search-style-1 search-style-1-lg mx-lg-auto"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Search"
                            v-model="searchField"
                            @input="debounceInput"
                          />
                          <button class="btn btn-default" type="submit">
                            <i class="bx bx-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="dataTables_wrapper dt-bootstrap5 no-footer"
              v-if="list.length > 0"
            >
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Naziv</th>
                      <th class="sorting">Opis</th>
                      <th class="sorting">Sistemska uloga?</th>
                      <th class="sorting">Broj permisija/ovlasti</th>
                      <th class="sorting">Vidi zaštićene dokumenate?</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(item, index) in list"
                      :key="item.id"
                      @click="openDetails(item.id)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="item.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                        <strong>{{
                          (searchConfig.page - 1) * searchConfig.pageSize +
                          index +
                          1
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{ item.name }}</strong>
                      </td>
                      <td>{{ item.description || 'N/A' }}</td>
                      <td>
                        <span
                          class="badge text-2"
                          :class="{
                            'text-success bg-soft-success': item.isSystemRole,
                            'text-danger bg-soft-danger': !item.isSystemRole,
                          }"
                        >
                          {{
                            item.isSystemRole && item.isSystemRole ? 'Da' : 'Ne'
                          }}
                        </span>
                      </td>
                      <td>
                        {{ item.permissionsCount }}
                      </td>
                      <td>
                        <span
                          class="badge text-2"
                          :class="{
                            'text-success bg-soft-success':
                              item.canSeeProtectedFiles,
                            'text-danger bg-soft-danger':
                              !item.canSeeProtectedFiles,
                          }"
                        >
                          {{
                            item.canSeeProtectedFiles &&
                            item.canSeeProtectedFiles
                              ? 'Da'
                              : 'Ne'
                          }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }}
                <a class="alert-link" @click.prevent="resetFilters">{{
                  translations.resetFilters
                }}</a
                >.
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                      >
                        {{ translations.apply }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="handleBulkAction"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations, pager } from '@/mixins';

import Pagination from '@/components/shared/Pagination.vue';
import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'Roles',
  mixins: [translations, pager],
  components: { Pagination, Modal },
  data() {
    return {
      actionName: 'getRoles',
      deleteActionName: 'deleteRoles',
      bulkActionName: 'deleteRoles',
    };
  },
  computed: {
    list() {
      return this.$store.getters.getRoles;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditUserRole', params: { id: id } });
    },
  }
};
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>
